module.exports = __webpack_public_path__ + "static/img/R-Icon-red.92c33009.png";